import * as Yup from 'yup';

const validationSchema = Yup.object({
    uuid_venue: Yup.string()
        .required('Venue is required'),
    uuid_turf: Yup.string()
        .required('Court is required'),
    name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Board name is required'),
    holiday_price: Yup.number('Amount must be a number')
        .positive('Amount must be a positive value')
        .required('Amount is required')
        .min(1, 'Your amount must be greater than or equal to 1!'),
    weekday_price: Yup.number('Amount must be a number')
        .positive('Amount must be a positive value')
        .required('Amount is required')
        .min(1, 'Your amount must be greater than or equal to 1!'),
    weekend_price: Yup.number('Amount must be a number')
        .positive('Amount must be a positive value')
        .required('Amount is required')
        .min(1, 'Your amount must be greater than or equal to 1!'),
    discount_percentage: Yup.number('Discount must be a number')
        .positive('Discount must be a positive value')
        .required('Discount is required')
        .min(0, 'Discount must be greater than or equal to 0!')
        .max(100, 'Discount must be less than or equal to 100!'),
    board_width: Yup.number('Board width must be a number')
        .positive('Board width must be a positive value')
        .required('Board width is required')
        .min(1, 'Your board width must be greater than or equal to 1!'),
    board_height: Yup.number('Board height must be a number')
        .positive('Board height must be a positive value')
        .required('Board height is required')
        .min(1, 'Your board height must be greater than or equal to 1!')
});

export default validationSchema;